import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

//Import languages
import en from '../../app/i18n/en';
import al from '../../app/i18n/al';

i18n
  .use(LanguageDetector) //Detect user's browser language - i18nextLng
  .use(initReactI18next) //Bind i18next to React
  .init({
    fallbackLng: 'en', //Default if user language not found
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ['en', 'al'],
    resources: {
      en,
      al,
    },
  });

export default i18n;
